export const IconMenuVerticalDots: {
  name: 'icon_menu_vertical_dots-12128462e2fa'
} = {
  name: 'icon_menu_vertical_dots-12128462e2fa'
}
